import React from 'react';
import Toast from '../common/Toast'
import util from "../../util/tools";
import './index.css';

export default class Home extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            curTitle: "签到",
            isShowSignCover: false,
            day:0,
            text:'',
            isStar:0,
        };
    }

    componentDidMount() {
        document.title = this.state.curTitle;

        this.isStar()
        this.result()
    }
    // 判断是否已签到
    isStar(){
        let date = new Date();
        let year = date.getFullYear()
        let month = (date.getMonth() + 1)>9?(date.getMonth() + 1):`0${(date.getMonth() + 1)}`; // 月
        let day  = date.getDate()>9?date.getDate():`0${date.getDate()}`; // 日
        let today = `${year}-${month}-${day}`;
        util.ajax({
            url: "/zh/send/one",
            isUser: true,
            isWechatId: true,
            data: {
                'signin_day':today,
                'type':1,
            },
            callback: res => {
                if (res.result.status.code == 0) {
                    let data = res.result.data;
                    if(!!data.coin){
                        this.setState({
                            isStar:1
                        })
                    }
                }

            }
        });
    }
    // 获取签到天数
    result(){
        util.ajax({
            url: "/zh/send/lists",
            isUser: true,
            isWechatId: true,
            data: {
                '__flush_cache': 1,
                'type':1,
                'page':1,
            },
            callback: res => {
                if (res.result.status.code == 0) {
                    this.setState({
                        day:res.result.total_num
                    })
                }
            }
        });
    }
    // 签到
    sign(){
        if(this.state.isStar == 0){//未签到
            util.ajax({
                url: "/zh/send/signin",
                method:'post',
                isUser: true,
                isWechatId: true,
                clearArr: ["/zh/send/lists"],
                callback: res => {
                    let tempData = {};
                    if (res.result.status.code == 0) {
                        tempData = {
                            day:parseInt(this.state.day)+1,
                            isShowSignCover:true,
                            isStar:1,
                        };
                    } else {
                        tempData = {
                            text:`${res.result.status.msg}`
                        };
                    }
                    this.setState(tempData,()=>{
                        if(!!tempData.text){
                            setTimeout(()=>{
                                this.setState({
                                    text: ""
                                });
                            },2000);
                        }
                    });
                }
            });
        }

    }
    //点击知道
    tapKnow(){
        this.setState({isShowSignCover: false})
    }

    render() {
        return (
            <div className='sign'>
                <div className='sign_header'></div>
                <span className='sign_font'>已累计签到</span>
                <span className='sign_num'>{this.state.day}天</span>
                <div className={`sign_btn ${this.state.isStar!=0 && "disab"}`} onClick={()=>this.sign()}>{this.state.isStar==0?'签到领20红包':'今日已签到'}</div>
                <div className='sign_tips'>* 红包有效期5天，过期自动失效。</div>
                <div className='sign_tips'>*【个人中心】-【我的红包】中可查看红包领取记录</div>
                {/*签到成功*/}
                {this.state.isShowSignCover &&
                <div className='signCover'>
                    <div className='signCover_box'>
                        <span className='signCover_box_success'>签到成功</span>
                        <div className='signCover_box_give'>赠送 <span
                            style={{color: '#FB004D', fontSize: '.4rem'}}>20</span> 红包</div>
                        <span onClick={()=>this.tapKnow()} className='signCover_box_know'>知道了</span>
                    </div>
                </div>
                }
                <Toast text={this.state.text}/>
            </div>
        );
    }
}